// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"BomWrapper__wrapper","cardHeader":"BomWrapper__cardHeader","tableHeader":"BomWrapper__tableHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BomWrapper/BomWrapper.scss
// module id = ./src/components/BomWrapper/BomWrapper.scss
// module chunks = 2